import { useService } from '../../../../../redux/reducer/service';
import useServiceData from '../../../../../hooks/useServiceData';
import { isString } from 'lodash';

export default function useCallIsNewFlag({ newFlagData, isNewFlag }) {
  const { serviceData } = useService();
  const { save } = useServiceData();

  return {
    callIsNewFlag() {
      if (isString(newFlagData) && isNewFlag) {
        const { disposableNewButtons = {} } = serviceData ?? {};
        save('disposableNewButtons', { ...disposableNewButtons, [newFlagData]: true });
      }
    },
  };
}
